export default __webpack_public_path__ + "static/enterprise-platform-testing-a7a7017e6c90b9a871c8bdc5e5c1e84f.jpg";